var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTelegram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 12,
    viewBox: "0 0 16 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.3447 0.0789028L1.35281 4.96642C0.466171 5.31384 0.471301 5.79638 1.19014 6.01155L4.52566 7.02665L12.2431 2.27639C12.608 2.05979 12.9414 2.17631 12.6674 2.41364L6.41472 7.9188H6.41326L6.41472 7.91952L6.18463 11.2737C6.5217 11.2737 6.67045 11.1228 6.85951 10.9448L8.47964 9.40786L11.8496 11.8363C12.471 12.1701 12.9172 11.9985 13.0719 11.2751L15.2841 1.10402C15.5105 0.218301 14.9375 -0.182737 14.3447 0.0789028Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelegram);
export default __webpack_public_path__ + "static/media/telegram.05fe6f9aab20a7c2f209817acda7025e.svg";
export { ForwardRef as ReactComponent };